import { Trophy, Star, Award } from "lucide-react";
import RevealOnScroll from "./RevealOnScroll";

export const AwardShowcase = () => (
  <section data-testid="award-showcase" className="relative overflow-hidden bg-[#0B0F19]">
    {/* ambient gold glow */}
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[320px] rounded-full bg-[#C9A227]/12 blur-[120px] pointer-events-none" />

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-12">
      <RevealOnScroll
        className="rounded-3xl p-[2px] bg-gradient-to-r from-[#E7C65A] via-[#C9A227] to-[#B8891F] shadow-[0_30px_80px_-25px_rgba(201,162,39,0.55)]"
        data-testid="award-showcase-card"
      >
        <div className="relative rounded-[22px] bg-gradient-to-br from-[#0E1322] via-[#121a30] to-[#0E1322] px-6 py-8 sm:px-10 sm:py-10 overflow-hidden">
          {/* shine sweep */}
          <div className="pointer-events-none absolute inset-0 opacity-40" style={{ background: "linear-gradient(120deg,transparent 30%,rgba(231,198,90,.18) 50%,transparent 70%)", backgroundSize: "200% 100%", animation: "cvGoldShine 6s linear infinite" }} />

          <div className="relative grid lg:grid-cols-2 gap-8 lg:gap-10 items-center">
            {/* Text side */}
            <div className="text-center lg:text-left">
              <span className="inline-flex items-center gap-2 bg-[#C9A227]/15 border border-[#C9A227]/45 rounded-full px-4 py-1.5 mb-5">
                <Award className="h-3.5 w-3.5 text-[#E7C65A]" />
                <span className="text-[#E7C65A] text-[11px] font-black uppercase tracking-[2.5px]">Reconocimiento oficial</span>
              </span>

              <div className="flex items-center justify-center lg:justify-start gap-3 mb-3">
                <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-[#E7C65A] to-[#B8891F] shadow-[0_10px_30px_-6px_rgba(201,162,39,0.6)] flex-shrink-0" style={{ animation: "cvFloat 4s ease-in-out infinite" }}>
                  <Trophy className="h-7 w-7 text-white" />
                </span>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-white leading-[1.1] tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  Club Viajemos <span className="text-slate-400 font-bold">+</span> <span style={{ color: "#F7501E" }}>Hotmart</span>
                  <span className="block bg-gradient-to-r from-[#E7C65A] to-[#C9A227] bg-clip-text text-transparent">= Equipo Ganador</span>
                </h2>
              </div>

              <p className="text-slate-300 text-sm sm:text-base font-semibold mb-5">
                <span className="text-[#E7C65A] font-black">Premio Keep Growing</span> · casi 6,000 agencias de viajes formadas
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-6 gap-y-2">
                <span className="inline-flex items-center gap-2 bg-white rounded-lg px-3 py-1.5 shadow-md" data-testid="award-hotmart-logo">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500">En alianza con</span>
                  <img src="/logos/hotmart.png" alt="Hotmart" className="h-5 w-auto object-contain" loading="lazy" />
                </span>
                <span className="inline-flex items-center gap-1.5 text-slate-200 text-sm font-semibold">
                  <Star className="h-4 w-4 text-[#E7C65A] fill-[#E7C65A]" /> Alianza premiada
                </span>
              </div>
            </div>

            {/* Images side */}
            <div className="flex items-center justify-center lg:justify-end gap-5 sm:gap-7">
              {[
                { src: "/reconocimientos/portrait.webp", alt: "Carlos Fernández", cap: "Carlos \"Miami\" Fernández" },
                { src: "/reconocimientos/premio.jpeg", alt: "Premio Keep Growing Hotmart", cap: "Premio Keep Growing" },
              ].map((img) => (
                <div key={img.alt} className="flex flex-col items-center gap-2.5">
                  <div className="relative group">
                    <div className="absolute -inset-1 rounded-full bg-gradient-to-br from-[#E7C65A] to-[#B8891F] blur-md opacity-50 group-hover:opacity-80 transition-opacity" />
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="relative w-28 h-28 sm:w-36 sm:h-36 rounded-full object-cover ring-4 ring-[#C9A84C] shadow-xl transition-transform duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  <span className="text-[11px] text-slate-400 font-semibold text-center max-w-[130px] leading-tight">{img.cap}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </RevealOnScroll>
    </div>
  </section>
);

export default AwardShowcase;
